<template>
  <div class="text-left">
    <div class="pb-2" v-if="queryCon.type == 7">
      <!--图片及订单简介-->
      <!-- <div class="d-center-around"> -->
      <el-row :gutter="60">
        <el-col :span="10">
          <el-carousel trigger="click" height="400px" style="max-width:540px">
            <el-carousel-item v-for="(item, index) in infoList.proPic" :key="index">
              <img class="caroimg" v-lazy="ImgPreUrl + item">
              <div class="text-center">{{index + 1}} / {{infoList.proPic.length}}</div>
            </el-carousel-item>
          </el-carousel>
        </el-col>
        <el-col :span="14" class="rightb">
          <div class="text-muted">
            <p class="h3 mb-5 text-dark">
              <span class="h6">{{infoList.type == 1 ? '限时优惠' : '限时抢购'}}</span>
              {{infoList.productName}}
            </p>
            <div class="d-center-start mb-3">
              <left-text leftText="价格" :width="60" />
              <div v-if="infoList.uid > 0">
                <span class="text-info h3">¥ {{infoList.price3}}</span><span class="text-dark">结算价</span>
                <span class="text-dark ml-2 mr-2"><span class="text-info">¥ </span>{{infoList.price2}}抢购价</span>(散客)
                <span class="line-through">¥ {{infoList.price1}}原价</span>
              </div>
              <div v-else>
                <span class="text-info h3">¥ {{infoList.price2}}</span><span class="text-dark">抢购价(散客)</span>
                <span class="text-dark ml-2 mr-2"><span class="text-info">¥ </span>{{infoList.price3}}结算价</span>
                <span class="line-through">¥ {{infoList.price1}}原价</span>
              </div>
              <!-- <span class="line-through h7">¥ {{infoList.price3}} 门市价</span> -->
            </div>
            <p class="d-center-start mb-3">
              <left-text leftText="订单号" :width="60" />
              <span>{{infoList.oid}}</span>
            </p>
            <p class="d-center-start mb-3">
              <left-text leftText="订单类型" :width="60" />
              <span v-if="infoList.type == 1">限时优惠</span>
              <span v-if="infoList.type == 2">限时抢购</span>
            </p>
            <p class="d-center-start mb-3">
              <left-text leftText="下单时间" :width="60" />
              <span>{{infoList.time | formatTimestamp(1)}}</span>
            </p>
            <p class="d-center-start mb-3" v-if="infoList.status === 14">
              <left-text leftText="支付时间" :width="60" />
              <span>{{infoList.deal_time | formatTimestamp(1)}}</span>
            </p>
            <p class="d-center-start mb-3" v-if="infoList.date_in">
              <left-text leftText="出行日期" :width="60" />
              <span>{{infoList.date_in | formatTimestamp()}}</span>
            </p>
            <p class="d-center-start mb-3">
              <left-text leftText="数量" :width="60" />
              <span class="text-dark">x {{infoList.num}}</span>
            </p>
          </div>
        </el-col>
      </el-row>
      <div v-if="infoList.status != 8">
        <div class="text-right alreadypay">
          <div class="text-right h5 text-muted" v-if="infoList.red_packet_pay > 0 && userLoginMessage.type == 99">红包抵扣：- &yen;{{(infoList.red_packet_pay / 100).toFixed(2)}}</div>
          已付金额：<span>{{((infoList.price_pay - infoList.red_packet_pay) / 100).toFixed(2)}}</span>元
        </div>        
      </div>
      <!-- </div> -->
    </div>
    <div v-else class="border-top pt-4 pb-4">
      <p class="d-center-start mb-3">
        <left-text leftText="下单时间" :width="60" /><span>{{infoList.time | formatTimestamp(1)}}</span>
      </p>
      <p class="d-center-start mb-3">
        <left-text leftText="订单号" :width="60" /><span>{{infoList.oid}}</span>
      </p>
      <p class="d-center-start mb-3">
        <left-text leftText="出行日期" :width="60" /><span>{{infoList.date_in | formatTimestamp}}</span>
      </p>
      <p class="d-center-start pt-1">
        <left-text v-if="infoList.status == 9" leftText="已付总额" :width="60" />
        <left-text v-else leftText="应付总额" :width="60" />
        <span class="text-danger" v-if="userLoginMessage.type == 99">&yen;{{infoList.price}}</span>
        <span class="text-danger" v-else>&yen; {{(Number(infoList.price_pay) / 100).toFixed(2)}}</span>
      </p>
    </div>
    <div class="pt-4 pb-4 border-top border-bottom gap">
      <div v-if="queryCon.type == 7"><h3 class="inmeal">套餐所含景点</h3><p v-for="(item, index) in infoList.proSub" :key="index">{{item.name}} + {{item.son_name}}</p></div>
      <div v-else>
        <h3 class="inmeal">票务信息</h3>
        <div v-for="(item,index) in infoList.ticket" :key="index">
          <p class="pt-1 pb-1">
              【{{item.ticket_species | formatVar('ticketTypeArr')}}】
              <span class="text-muted">{{item.ticket_name}}</span>
              <span class="text-orange ml-auto h6" v-show="item.discount>0">已在线立减 &yen;{{item.discount * item.num}}元</span>
          </p>
          <el-row class="pt-1 pb-1" v-if="item.scene_date"><el-col :span="6">场次</el-col><el-col :span="18" class="active">{{item.scene_date}}</el-col></el-row>
          <el-row class="pt-1 pb-1" v-if="item.seat_name">
              <el-col :span="6">座位区域</el-col>
              <el-col :span="18" class="active">{{item.seat_name}} / &yen; {{(item.price / item.num).toFixed(2)}}</el-col>
          </el-row>
          <el-row class="pt-1 pb-1 text-warning">
            <el-col :span="6" v-if="userLoginMessage.type == 99">
              <span v-if="item.seat_name">{{item.seat_price}}</span><span v-else>{{item.price3}}</span> 元 / 张
            </el-col>
            <el-col :span="6" v-else>&yen;{{(item.price / item.num).toFixed(2)}} 元 / 张</el-col>
            <el-col :span="18">x {{item.num}}</el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!--购买人信息-->
    <div class="pt-4 pb-4 gap">
      <h3 class="pb-3">购买人信息</h3>
      <p>联系人：{{infoList.occupant_name}}</p>
      <p>电话号码：{{infoList.occupant_mobile}}</p>
      <p>身份证号：{{infoList.id_card}}</p>
    </div>
    <div class="pt-4 pb-4 border-top gap" v-if="infoList.status === 9 && infoList.check_code">
      <h3 class="pb-3">凭证信息</h3>
      <p>凭证类型：{{CheckType.title}}</p>
      <p>凭证码：{{infoList.check_code}}</p>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: 'BasicInfo',
    props: ['infoList'],
    data() {
      return {
        displayImg: '',                            //展示的图片
        interval: null
      }
    },
    computed: {
      ...mapState(['userLoginMessage']),
      CheckType() {
        let Ctype = {};
        switch (this.infoList.check_type) {
          case 0 : Ctype = {title: '未知'}; break;
          case 1 : Ctype = {title: '身份证'}; break;
          case 2 : Ctype = {title: '手机号'}; break;
          case 3 : Ctype = {title: '校验码'}; break
        }
        return Ctype;
      },
      queryCon () { return this.$route.query }
    },
    watch: {
      // 'infoList.proPic': {
      //   handler(val) { this.displayImg = val[0]; }
      // }
      // 'infoList.status': {
      //   handler(val) {
      //     if (this.infoList.status === 8) {
      //       this.countdown(1800000, 'time')
      //     } else if (this.infoList.status === 14) {
      //       this.countdown(900000, 'deal')
      //     }
      //   }
      // }
    }
  }
</script>
<style lang="scss" scoped>
  .rightb{
    height: 400px!important;
  }
  .caroimg{
    width: 100%;
    height: 100%
  }
  .alreadypay{
    margin: 35px 0 35px 0;
    span{
      font-size: 24px;
      font-weight: bold;
      color: #c16774
    }
  }
  .inmeal{
    line-height: 50px
  }
  .gap{
    p{
      line-height: 22px
    }
  }
</style>
